import React, { memo } from "react";
import { Button, Space, Row } from "antd";
import { createUseStyles } from "react-jss";
import { COLORS, i18n, useThemes } from "core/src";
import { MessageOutlined, ClockCircleOutlined } from "@ant-design/icons"; // Adjust if you have a custom Icon component
import { Text } from "components/src";

const useStyles = createUseStyles<string, unknown, COLORS>((colors) => ({
  sendAgainText: {
    fontWeight: "bold",
    marginRight: "16px !important",
    marginLeft: "25px !important",
    fontSize: 12,
    color: colors.gray, // Replace with actual color value
  },
  sendAgainContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    backgroundColor: 'transparent'
  },
  counter: {
    fontSize: 12,
    color: colors.gray01, // Replace with actual color value
    marginLeft: "14px !important",
    marginRight: "14px !important",
  },
  spaceSendAgainBellow: {
    flex: 1,
    flexGrow: 2,
    maxHeight: 10,
  },
}));

interface Props {
  counter: number;
  counterStatus: boolean;
  requestCode: () => void;
  title?: string;
}
const ActivationCodeRequest = memo<Props>(
  ({ counter, counterStatus, requestCode, title }) => {
    const styles = useStyles();
    const { colors } = useThemes();

    return (
      <>
        <Button
          disabled={counterStatus}
          onClick={requestCode}
          className={styles.sendAgainContainer}
        >
          <Space>
            <MessageOutlined style={{ color: colors.red }} />
            <Text className={styles.sendAgainText}>
              {" "}
              {counterStatus
                ? i18n.t("sendActivationCodeAgain")
                : title || i18n.t("resendActivationCodeAgain")}
              {"  "}
            </Text>
            {counterStatus && (
              <Row>
                {" "}
                <Text className={styles.counter}>{counter}</Text>{" "}
                <ClockCircleOutlined style={{ color: colors.red }} />{" "}
              </Row>
            )}
          </Space>
        </Button>
        <Space className={styles.spaceSendAgainBellow} />
      </>
    );
  }
);

export { ActivationCodeRequest };
